import { render, staticRenderFns } from "./imageTextResource.vue?vue&type=template&id=58fa2db6&"
import script from "./imageTextResource.vue?vue&type=script&lang=js&"
export * from "./imageTextResource.vue?vue&type=script&lang=js&"
import style0 from "./imageTextResource.vue?vue&type=style&index=0&id=58fa2db6&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/zhishengluo/opp-scratch/scratch/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58fa2db6')) {
      api.createRecord('58fa2db6', component.options)
    } else {
      api.reload('58fa2db6', component.options)
    }
    module.hot.accept("./imageTextResource.vue?vue&type=template&id=58fa2db6&", function () {
      api.rerender('58fa2db6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/resource/imageTextResource.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/resource/imageTextResource.vue
// module id = h8yx
// module chunks = 0